import React from "react";

const LoveLocal = () => (
  <div className="tab-info our-local" id="our-local">
    <h4>Our Local E Story</h4>
    <p>
      It started with an idea… as all ideas do. Funny that. Click below to find
      out more.
    </p>
    <a href="/about-us" className="btn btn-blue">
      More about us
    </a>
  </div>
);

export default LoveLocal;
